
import popup from '~/components/compare/popup.vue'
export default {
  name: 'CompareDetails',
  components: {
    'dealer-intro': popup
  },
  props: {
    urlNameList: {
      type: Array,
      default: () => {}
    },
    list: {
      type: Array,
      default: () => {}
    },
    atArr: {
      type: Array,
      default: () => {}
    },
    // 是否是forex 路由
    forex: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      intro: '',
      urlName: ''
      // isShow: false
    }
  },
  computed: {
    content() {
      return (this.list && this.list[0] && this.list[0].content) || null
    },
    content1() {
      return (this.list && this.list[1] && this.list[1].content) || null
    },
    content2() {
      return (this.list && this.list[2] && this.list[2].content) || null
    }
  },
  mounted() {
    console.log(this.list, '数据')
  },
  methods: {
    dealintro(txt) {
      if (txt) {
        for (let i = 0; i < 9999; i++) {
          if (txt.includes('<p>　　')) {
            txt = txt ? txt.replace('<p>　　', '<p>') : '--'
          } else {
            break
          }
        }
      }
      return txt
    },
    popup(context, name) {
      if (!this.$store.state.mobile) {
        this.urlName = name
        this.intro = context
        this.$refs.popUp.show()
      } else {
        window.open(`/${this.$store.state.LanguageCode}/download.html`)
      }
    }
  }
}
